export const isDesa = () => window.location.hostname === 'erp.desa.balanced.plus'; //TODO this needs to be better